<template>
  <div class="companyBox">
    <Form ref="searchForm" :label-width="90" :model="formCustom" inline>
      <Form-item label="姓名：">
        <Input
          v-model="formCustom.zgxm"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="家属姓名：">
        <Input
          v-model="formCustom.jsxm"
          :maxlength="50"
          clearable
          style="width: 200px"
        ></Input>
      </Form-item>
      <Form-item label="证件类型：">
        <Select v-model="formCustom.zjlx" clearable filterable style="width: 200px">
          <Option value="护照">护照</Option>
          <Option value="居留许可证">居留许可证</Option>
          <Option value="工作许可证">工作许可证</Option>
        </Select>
      </Form-item>
      <Form-item label="到期日期：">
        <el-date-picker
          v-model="formCustom.dqrq"
          end-placeholder="结束日期"
          size="small"
          start-placeholder="开始日期"
          type="daterange">
        </el-date-picker>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')"
        >重置
        </Button
        >
      </Form-item>
    </Form>
    <el-tabs v-model="activeName" @tab-click="tabclick">
      <el-tab-pane label="待处理" name="0">
        <div>
          <Table
            :columns="companyColumns"
            :data="companyTableData"
            :loading="loading"
            aria-hidden="true"
            border
          >
            <template slot="action" slot-scope="{ row }">
              <Button
                v-if="row.zjlx !='护照'"
                size="small"
                type="text"
                @click="goExport(row)"
              >导出证明文件
              </Button>
              <Button
                v-if="row.zjlx =='护照'"
                size="small"
                type="text"
                @click="goHandle(row)"
              >去处理
              </Button>
              <Button
                v-if="row.zjlx =='护照'"
                size="small"
                type="text"
                @click="goTip(row)"
              >提醒
              </Button>
              <Button
                v-if="row.employeeFamilyMemberId"
                size="small"
                type="text"
                @click="markingState(row)"
              >标记状态
              </Button>
            </template>
            <template slot="dqrq" slot-scope="{ row }">
              <p v-if="row.dqrq">{{ row.dqrq }}</p>
              <p v-else>待入职</p>
            </template>
          </Table>
          <Page
            ref="pages"
            :current="page"
            :total="total"
            class="page_position"
            show-elevator
            show-sizer
            show-total
            @on-change="setCurrent"
            @on-page-size-change="setPage"
          ></Page>
        </div>
      </el-tab-pane>
      <el-tab-pane label="处理中" name="1">
        <div>
          <Table
            :columns="companyColumns"
            :data="companyTableData"
            :loading="loading"
            aria-hidden="true"
            border
          >
            <template slot="action" slot-scope="{ row }">
              <Button
                v-if="row.zjlx !='护照'"
                size="small"
                type="text"
                @click="goExport(row)"
              >导出证明文件
              </Button>
              <Button
                size="small"
                type="text"
                @click="goHandle(row)"
              >去处理
              </Button>
              <Button
                v-if="row.employeeFamilyMemberId"
                size="small"
                type="text"
                @click="markingState(row)"
              >标记状态
              </Button>
            </template>
            <template slot="dqrq" slot-scope="{ row }">
              <p v-if="row.dqrq">{{ row.dqrq }}</p>
              <p v-else>待入职</p>
            </template>
          </Table>
          <Page
            ref="pages1"
            :current="page"
            :total="total"
            class="page_position"
            show-elevator
            show-sizer
            show-total
            @on-change="setCurrent"
            @on-page-size-change="setPage"
          ></Page>
        </div>
      </el-tab-pane>
      <el-tab-pane label="已处理" name="2">
        <div>
          <Table
            :columns="columns"
            :data="companyTableData"
            :loading="loading"
            aria-hidden="true"
            border
          >
            <template slot="markStatus" slot-scope="{ row }">
              {{
                row.markStatus == 0 ? '服务中' : row.markStatus == 1 ? '不在境内' : row.markStatus == 2 ? '转化为学生签,工作签' : row.markStatus == 3 ? '已满18周岁' : '员工离职'
              }}
            </template>
          </Table>
          <Page
            ref="pages2"
            :current="page"
            :total="total"
            class="page_position"
            show-elevator
            show-sizer
            show-total
            @on-change="setCurrent"
            @on-page-size-change="setPage"
          ></Page>
        </div>
      </el-tab-pane>
    </el-tabs>
    <exportfile
      :model="addrowExportfile"
      :visible="visibleExportfile"
      @cancel="handleCancelExportfile"
      @success="successexportfile"
    />
    <el-dialog :visible.sync="visibleAdd" title="处理" width="500px">
      <Form ref="searchForm" :label-width="90" :model="formCustomc">
        <Form-item v-if="row.zjlx == '护照'" label="护照号码：">
          <Input v-model="formCustomc.hzhm" :disabled="select" clearable style="width: 200px"></Input>
        </Form-item>
        <Form-item v-if="row.zjlx == '居留许可证'" label="居留许可证编号：">
          <Input v-model="formCustomc.jlxkzbh" :disabled="select" clearable
                 style="width: 200px"></Input>
        </Form-item>
        <Form-item v-if="row.zjlx == '工作许可证'" label="工作许可证发证日期：">
          <DatePicker :disabled="select" :options="options1" :value="formCustomc.gzxkzfzrq" format="yyyy-MM-dd"
                      style="width: 200px;"
                      type="date" @on-change="changegzxkzfzrq"/>
        </Form-item>
        <Form-item v-if="row.zjlx == '护照' && !row.jsxm" label="护照签发日期：">
          <DatePicker :disabled="select" :options="options1" :value="formCustomc.hzqfrq" format="yyyy-MM-dd"
                      style="width: 200px;"
                      type="date" @on-change="changehzqfrq"/>
        </Form-item>
        <Form-item v-if="row.zjlx == '居留许可证'" label="居留许可证签发日期：">
          <DatePicker :disabled="select" :options="options1" :value="formCustomc.jlxkzqfrq" format="yyyy-MM-dd"
                      style="width: 200px;"
                      type="date" @on-change="changejlxkzqfrq"/>
        </Form-item>
        <Form-item label="到期日期：">
          <DatePicker :options="options2" :value="formCustomc.dqrq" format="yyyy-MM-dd" style="width: 200px;"
                      type="date"
                      @on-change="changecsnyr"/>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="process">确认</Button>
        </Form-item>
      </Form>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisible" title="标记状态" width="500px">
      <Form ref="searchForm" :label-width="90" :model="formCustom">
        <Form-item label="选择状态：">
          <Select v-model="markStatus" clearable filterable style="width: 200px">
            <Option value="1">不在境内</Option>
            <Option value="2">转化为学生签,工作签</Option>
            <Option value="3">已满18周岁</Option>
            <Option value="4">员工离职</Option>
          </Select>
        </Form-item>
        <Form-item>
          <Button type="primary" @click="put">确认</Button>
        </Form-item>
      </Form>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from "@/libs/handlePermission.ts";
import addforeignEmployess from "./addforeignEmployess.vue"
import exportfile from "@/views/employee/exportfile.vue"
import {employeeHandle, employeeMarkStatus, employeeProcessPage, employeeWarn} from "@/api/employee";

export default {
  name: "company",
  data() {
    return {
      hzqfrq: '',
      gzxkzfzrq: '',
      jlxkzqfrq: '',
      options1: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      },
      options2: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      formCustomc: {},
      isuploadExportfile: true,
      addrowExportfile: {},
      selectExportfile: false,
      visibleExportfile: false,
      activeName: '0',
      absenteeismUrl: '',
      dialogFormVisible: false,
      visibleAdd: false,
      select: false,
      visibleFillIn: false,
      addRow: {},
      dialogVisible: false,
      markStatus: '',
      dialogTableVisible: false,
      dialogWorkerVisible: false,
      tableData: [],
      total: 0,
      page: 1,
      dialogtotal: 0,
      dialogpage: 1,
      dialogloading: false,
      dialogWorkerloading: false,
      tableWorkerData: [],
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      companyIds: "",
      formCustomTable: {},
      formCustom: {},
      asyncRoute: {
        pass: '1',
        checkIdea: ''
      },

      companyColumns: [
        {title: "姓名", key: "zgxm", align: "center"},
        {title: "家属姓名", key: "jsxm", align: "center"},
        {title: "证件类型", key: "zjlx", align: "center"},
        {title: "到期日期", key: "dqrq", slot: 'dqrq', align: "center"},
        {title: "操作", slot: "action", align: "center", fixed: "right"},
      ],
      columns: [
        {title: "姓名", key: "zgxm", align: "center"},
        {title: "家属姓名", key: "jsxm", align: "center"},
        {title: "证件类型", key: "zjlx", align: "center"},
        {title: "标记状态", key: "markStatus", slot: "markStatus", align: "center"},
        {title: "到期日期", key: "dqrq", align: "center"},
      ],
      companyTableData: [], // 表格数据
      row: {},
      areaData: [],
      countyCode: "",
      industryTypeList: [], // 行业类型
      companyScaleList: [], // 企业规模
      addDialogVisible: false,
      editDialogVisible: false,
      dialogAuditVisible: false,
      roleType: '',
      companyAttendanceIds: '',
      val: new Date(),
      daylist: [],
      holidaylist: [],
      cutoffTime: '',
      isupload: false,
      workerRow: {},
      employeerow: {},
      isuploadWorker: false,
      attendanceDate: '',
      BaseUrl: process.env.VUE_APP_BASE_URL,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("getToken"),
      },
      upAction: this.$getImg + 'api/auth/file', // 上传图片网址
      getToken: {Authorization: 'Bearer ' + localStorage.getToken},
    }
  },
  components: {
    addforeignEmployess,
    exportfile
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem("routerList"))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
    let token = localStorage.getItem('getToken')
    let userString = decodeURIComponent((window.atob(token.split('.')[1].replace(/-/g, "+").replace(/_/g, "/"))))
    let user = JSON.parse(userString)
    this.roleType = user.roleType
    console.log(this.roleType)
  },
  methods: {
    markingState(row) {
      this.row = row
      this.dialogVisible = true
    },
    put() {
      employeeMarkStatus({
        employeeProcessId: this.row.employeeProcessId,
        markStatus: this.markStatus,
        status: 2
      }).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.dialogVisible = false
          this.init()
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    goExport(row) {
      if (row.auditStatus == 0) {
        this.$confirmss('此人员有未复核的信息，是否继续导出？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '去复核',
          type: 'warning'
        }).then(() => {
          this.addrowExportfile = row
          this.visibleExportfile = true
        }).catch(() => {
          this.$router.push({path: '/employee/employee', query: {check: true}})
        })
      } else {
        this.addrowExportfile = row
        this.visibleExportfile = true
      }
    },
    goHandle(row) {
      this.row = row
      this.visibleAdd = true
      this.formCustomc.dqrq = row.dqrq
      this.formCustomc.hzhm = row.hzhm
      this.formCustomc.hzqfrq = row.hzqfrq
      this.formCustomc.jlxkzbh = row.jlxkzbh
      this.formCustomc.jlxkzqfrq = row.jlxkzqfrq
      this.formCustomc.gzxkzfzrq = row.gzxkzfzrq
      if (row.dqrq) {
        this.options1 = {
          disabledDate(date) {
            return date && date.valueOf() > Date.parse(new Date(row.dqrq));
          }
        }
      } else {
        this.options1 = {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        }
      }
      if (row.hzqfrq) {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.parse(new Date(row.hzqfrq));
          }
        }
      } else if (row.jlxkzqfrq) {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.parse(new Date(row.jlxkzqfrq));
          }
        }
      } else {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        }
      }
    },
    downloadFile(row) {
      window.open(row.templatePath)
    },
    uploadFile(row) {
      this.workerRow = row
      if (this.$refs.upload != undefined) {
        this.$refs["upload"].clearFiles()
      }
      this.dialogFormVisible = true
      this.absenteeismUrl = ''
    },
    handleSuccess(response) {
      this.absenteeismUrl = this.$getImgFile + response.data
    },
    handleError(error, file) {
      this.$message.error(file.msg)
    },
    // 超出限制大小
    handleMaxSize() {
      this.$message.error('所传图片不能超过2M,请重新选择')
    },
    // 验证失败钩子
    handleFormatError() {
      this.$message.error('请上传正确的图片格式，仅支持jpg，jpeg，png三种格式')
    },
    cancelAudit() {
      this.dialogAuditVisible = false
      // this.asyncRoute.checkIdea = ''
    },
    successadd() {
      this.init()
      this.visibleAdd = false
    },
    addEvaluation() {
      this.addRow = {}
      this.isupload = false
      this.select = false
      this.visibleAdd = true
    },
    save() {
      this.visibleFillIn = false
      this.handleSearchWorker()
    },
    handleCancelAdd() {
      this.visibleAdd = false
    },
    gofillIn(row) {
      this.row = row
      this.visibleFillIn = true
    },
    handleCancelFillIn() {
      this.visibleFillIn = false
    },
    // 初始化
    init() {
      this.loading = true
      let params = {}
      if (this.formCustom.dqrq) {
        params.dqrqStart = this.$moment(this.formCustom.dqrq[0]).format("YYYY-MM-DD")
        params.dqrqEnd = this.$moment(this.formCustom.dqrq[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      if (this.formCustom.zjlx) params.zjlx = this.formCustom.zjlx
      employeeProcessPage({
        current: 1,
        size: 10,
        status: this.activeName,
        ...params
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1;
      });
    },
    selectionChange(rows) {
      if (rows && rows.length > 0) {
        let ids = [];
        console.log(rows)
        rows.forEach((row) => {
          ids.push(row.companyAttendanceId);
        });
        this.companyAttendanceIds = ids.join(",");
      } else {
        this.companyAttendanceIds = ''
      }
    },
    check(row) {//查看详情
      this.addRow = row
      this.isupload = true
      this.visibleAdd = true
      this.select = true
    },
    checks(row) {//编辑详情
      this.addRow = row
      this.isupload = true
      this.select = false
      this.visibleAdd = true
    },
    goEmployee(row) {//查看职工
      this.row = row
      this.dialogTableVisible = true
      pageCompanyEvaluationEmployee({
        companyEvaluationId: row.companyEvaluationId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    checkWorker(row) {//查看职工详情
      this.employeerow = row
      this.dialogWorkerVisible = true
      companyEvaluationEmployeeRecordPage({
        companyEvaluationEmployeeId: row.companyEvaluationEmployeeId,
        current: 1,
        size: 10
      }).then((res) => {
        this.dialogWorkerchangeData(res);
      });
    },

    checksWorker(row) {//查看详情
      this.workerRow = row
      this.visibleFillIn = true
    },
    deleteEvaluation(row) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          companyEvaluationDelete({companyEvaluationId: row.companyEvaluationId}).then((res) => {
            if (res.data.success === false) {
              this.$message.warning(res.data.msg)
            } else {
              this.$message.success(res.data.msg)
            }
            this.init()
          }).catch((error) => {
            this.$message.error(error.response.data.msg)
          })
        },
        onCancel: () => {
          this.$message.info('已取消删除')
        }
      })
    },
    // 查询
    handleSearchWorker() {
      companyEvaluationEmployeeRecordPage({
        companyEvaluationEmployeeId: this.workerRow.companyEvaluationEmployeeId,
        current: 1,
        size: 10,
      }).then((res) => {
        this.dialogWorkerchangeData(res);
      });
    },
    handleSearchEmployee() {
      pageCompanyEvaluationEmployee({
        current: 1,
        size: 10,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    handleSearch() {
      this.loading = true
      let params = {}
      if (this.formCustom.dqrq) {
        params.dqrqStart = this.$moment(this.formCustom.dqrq[0]).format("YYYY-MM-DD")
        params.dqrqEnd = this.$moment(this.formCustom.dqrq[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      if (this.formCustom.zjlx) params.zjlx = this.formCustom.zjlx
      employeeProcessPage({
        current: 1,
        size: this.pageSize,
        status: this.activeName,
        ...params
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },

    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total;
      this.size = res.data.data.size;
      this.companyTableData = res.data.data.records;
      this.loading = false;
    },
    dialogchangeData(res) {
      this.dialogtotal = res.data.data.total;
      this.dialogsize = res.data.data.size;
      this.tableData = res.data.data.records;
      this.dialogloading = false;
    },
    dialogWorkerchangeData(res) {
      this.dialogWorkertotal = res.data.data.total;
      this.dialogWorkersize = res.data.data.size;
      this.tableWorkerData = res.data.data.records;
      this.dialogWorkerloading = false;
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.formCustom = {}
      this.handleSearch();
    },
    // 重置
    handleResetEmployee(name) {
      this.$refs[name].resetFields();
      // 重置查询条件会再次查询
      this.handleSearchEmployee();
    },
    // 改变页码
    dialogsetCurrent(val) {
      this.dialogloading = true;
      this.dialogpage = val;
      pageCompanyEvaluationEmployee({
        current: val,
        size: this.pageSize,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
      });
    },
    // 改变每页条数
    dialogsetPage(val) {
      this.dialogloading = true;
      this.pageSize = val;
      pageCompanyEvaluationEmployee({
        current: 1,
        size: this.pageSize,
        companyEvaluationId: this.row.companyEvaluationId,
        companyName: this.formCustomTable.companyName,
        deptName: this.formCustomTable.deptName,
        employeeRealName: this.formCustomTable.employeeRealName,
        status: this.formCustomTable.status
      }).then((res) => {
        this.dialogchangeData(res);
        this.$refs["dialogpages"].currentPage = 1; // 分页变成第一页
      });
    },
    setCurrent(val) {
      this.loading = true
      this.loading = true;
      this.page = val;
      let params = {}
      if (this.formCustom.dqrq) {
        params.dqrqStart = this.$moment(this.formCustom.dqrq[0]).format("YYYY-MM-DD")
        params.dqrqEnd = this.$moment(this.formCustom.dqrq[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      if (this.formCustom.zjlx) params.zjlx = this.formCustom.zjlx
      employeeProcessPage({
        current: val,
        status: this.activeName,
        size: this.pageSize,
        ...params,
      }).then((res) => {
        this.changeData(res);
      });
    },
    // 改变每页条数
    setPage(val) {
      this.loading = true
      this.loading = true;
      this.pageSize = val;
      let params = {}
      if (this.formCustom.dqrq) {
        params.dqrqStart = this.$moment(this.formCustom.dqrq[0]).format("YYYY-MM-DD")
        params.dqrqEnd = this.$moment(this.formCustom.dqrq[1]).format("YYYY-MM-DD")
      }
      if (this.formCustom.zgxm) params.zgxm = this.formCustom.zgxm
      if (this.formCustom.jsxm) params.jsxm = this.formCustom.jsxm
      if (this.formCustom.zjlx) params.zjlx = this.formCustom.zjlx
      employeeProcessPage({
        current: 1,
        status: this.activeName,
        size: this.pageSize,
        ...params,
      }).then((res) => {
        this.changeData(res);
        this.$refs["pages"].currentPage = 1; // 分页变成第一页
      });
    },
    audit(row) {
      this.workerRow = row
      this.dialogAuditVisible = true
      this.asyncRoute.checkIdea = ''
      this.asyncRoute.pass = '1'
    },
    handleCancelExportfile() {
      this.visibleExportfile = false
    },
    tabclick() {
      this.init()
    },
    goTip(row) {
      employeeWarn({
        employeeProcessId: row.employeeProcessId,
        status: 1,
      }).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.visibleAdd = false
          this.init()
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    changecsnyr(t) {
      this.formCustomc.dqrq = t
      if (t) {
        this.options1 = {
          disabledDate(date) {
            return date && date.valueOf() > Date.parse(new Date(t));
          }
        }
      } else {
        this.options1 = {
          disabledDate(date) {
            return date && date.valueOf() > Date.now();
          }
        }
      }
    },
    changegzxkzfzrq(t) {
      this.formCustomc.gzxkzfzrq = t
      if (t) {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.parse(new Date(t));
          }
        }
      } else {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        }
      }
    },
    changehzqfrq(t) {
      this.formCustomc.hzqfrq = t
      if (t) {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.parse(new Date(t));
          }
        }
      } else {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        }
      }
    },
    changejlxkzqfrq(t) {
      this.formCustomc.jlxkzqfrq = t
      if (t) {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.parse(new Date(t));
          }
        }
      } else {
        this.options2 = {
          disabledDate(date) {
            return date && date.valueOf() < Date.now() - 86400000;
          }
        }
      }
    },
    process() {
      let params = {
        employeeProcessId: this.row.employeeProcessId,
        status: 2,
        dqrq: this.formCustomc.dqrq
      }
      if (this.row.zjlx == '护照' && this.formCustomc.hzhm) params.hzhm = this.formCustomc.hzhm
      if (this.row.zjlx == '护照' && this.formCustomc.hzqfrq && !this.row.jsxm) params.hzqfrq = this.formCustomc.hzqfrq
      if (this.row.zjlx == '居留许可证' && this.formCustomc.jlxkzbh) params.jlxkzbh = this.formCustomc.jlxkzbh
      if (this.row.zjlx == '居留许可证' && this.formCustomc.jlxkzqfrq) params.jlxkzqfrq = this.formCustomc.jlxkzqfrq
      if (this.row.zjlx == '工作许可证' && this.formCustomc.gzxkzfzrq) params.gzxkzfzrq = this.formCustomc.gzxkzfzrq
      employeeHandle(params).then((res) => {
        if (res.data.success) {
          this.$message.success(res.data.msg)
          this.visibleAdd = false
          this.init()
        } else {
          this.$message.error(res.data.msg)
        }
      });
    },
    successexportfile() {
      this.init()
    }
  }
}
</script>
<style lang="less">
.red {
  background-color: rgba(243, 12, 1, 0.48);
  color: rgb(0, 0, 0);
  padding: 8px;
}

.green {
  background-color: rgba(66, 165, 111, 0.5);
  padding: 8px;
  color: rgba(55, 55, 55);
}

.el-calendar-table td .el-calendar-day {
  padding: 0;
}

.el-calendar__header {
  display: none
}
</style>
